import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, X, BadgeCheck, Store } from "lucide-react";

export const MarketSearchBar = ({ value, onSearch, scope }) => {
  const [text, setText] = useState(value);
  useEffect(() => { setText(value); }, [value]);
  const submit = (e) => { e.preventDefault(); onSearch(text.trim()); };
  const clear = () => { setText(""); onSearch(""); };
  return (
    <form onSubmit={submit} data-testid="market-search-form" className="px-6 pt-4">
      <div className="relative max-w-6xl mx-auto flex items-center gap-2">
        <div className="relative flex-1">
          <Search className="h-4 w-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-[#6B7280]" />
          <input
            data-testid="market-search-input"
            type="search"
            enterKeyHint="search"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder={scope ? `Search in ${scope}` : "Search notes, descriptions or creators"}
            className="w-full h-11 pl-10 pr-10 rounded-full bg-[#1E1E1E] border border-[#27272A] text-sm text-[#F3F4F6] placeholder:text-[#6B7280] focus:outline-none focus:border-[#3B82F6] [&::-webkit-search-cancel-button]:hidden"
          />
          {(text || value) && (
            <button type="button" data-testid="market-search-clear-btn" aria-label="Clear search" onClick={clear}
              className="absolute right-2 top-1/2 -translate-y-1/2 h-7 w-7 rounded-full flex items-center justify-center text-[#9CA3AF] hover:text-white hover:bg-white/10 transition-colors">
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
        <button type="submit" data-testid="market-search-submit-btn" disabled={!text.trim()}
          className="h-11 px-5 rounded-full bg-[#2563EB] hover:bg-[#1D4ED8] text-white text-sm font-medium disabled:opacity-40 transition-colors">
          Search
        </button>
      </div>
    </form>
  );
};

export const CreatorResults = ({ creators }) => {
  if (!creators.length) return null;
  return (
    <section data-testid="market-creator-results">
      <h3 className="text-[10px] uppercase tracking-wider text-[#6B7280] mb-3 flex items-center gap-1.5">
        <Store className="h-3.5 w-3.5" /> Creators
      </h3>
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1 no-scrollbar">
        {creators.map((c) => (
          <Link key={c.seller_id} to={`/seller/${c.seller_id}`} data-testid={`market-creator-${c.seller_id}`}
            className="shrink-0 flex items-center gap-3 rounded-2xl bg-[#121212] border border-[#1E1E1E] hover:border-[#2563EB]/60 px-3 py-2.5 pr-5 transition-colors">
            {c.picture ? (
              <img src={c.picture} alt="" className="h-10 w-10 rounded-full object-cover" />
            ) : (
              <div className="h-10 w-10 rounded-full bg-[#2563EB] flex items-center justify-center font-semibold text-white">
                {(c.seller_name || "?").charAt(0).toUpperCase()}
              </div>
            )}
            <div className="min-w-0">
              <div className="flex items-center gap-1 text-sm font-semibold text-[#F3F4F6] max-w-[160px]">
                <span className="truncate">{c.seller_name}</span>
                {c.verified && <BadgeCheck className="h-3.5 w-3.5 text-[#3B82F6] shrink-0" aria-label="Verified seller" />}
              </div>
              <div className="text-[11px] text-[#9CA3AF]">{c.product_count} {c.product_count === 1 ? "note" : "notes"}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
